import { useState } from "react";
import moment from "moment";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Content, PaginationTableFilter, PaginationTable, ButtonLink } from "@webtypen/react-components";
import { Page } from "../../components/Page";

export const WorkingHoursOverview = () => {
    const [filter, setFilter] = useState({});

    return (
        <Page icon={faUsers} title="Arbeitszeiten">
            <Content>
                {/* <PaginationTableFilter
                    definition={{
                        lastname: { type: "text", label: "Nachname" },
                        firstname: { type: "text", label: "Vorname" },
                        email: { type: "text", label: "E-Mail" },
                        number: { type: "text", label: "Mitarbeiter-Nr." },
                    }}
                    filter={filter}
                    setFilter={setFilter}
                /> */}
                <PaginationTable
                    url="/api/working-hours/list"
                    tableAttributes={{ className: "valign-middle" }}
                    payload={{ filter: filter }}
                    columns={[
                        { label: "Name" },
                        { label: "Start", attributes: { style: { width: 60 } } },
                        { label: "Ende", attributes: { style: { width: 60 } } },
                        { label: "Stunden", attributes: { style: { width: 60 } } },
                        // { label: "Optionen", attributes: { style: { width: 130 }, className: "text-right" } },
                    ]}
                    render={(row, i) => (
                        <tr key={i}>
                            <td>
                                {row.user_object ? (
                                    <div>
                                        {row.user_object.firstname + " " + row.user_object.lastname}
                                        <div style={{ fontSize: 12 }}>{row.user_object.email}</div>
                                    </div>
                                ) : (
                                    "-"
                                )}
                            </td>
                            <td>{row.started_at ? moment(row.started_at).format("DD.MM.YYYY HH:mm") + " Uhr" : "-"}</td>
                            <td>{row.ended_at ? moment(row.ended_at).format("DD.MM.YYYY HH:mm") + " Uhr" : "-"}</td>
                            <td>{row.hours ? row.hours : "-"}</td>
                            {/* <td className="text-right">
                                <ButtonLink to={"/working-hours/" + row._id + "/edit"} sm>
                                    Bearbeiten
                                </ButtonLink>
                            </td> */}
                        </tr>
                    )}
                />
            </Content>
        </Page>
    );
};
